export function dashboardHomeSurface({ mode, canChat }) {
    if (mode !== "dashboard") return null;
    return canChat ? "chat" : null;
}
